// Calls the backend /api/classify-categories endpoint for a batch of
// extracted products. Safe to call for single-product inputs too — it
// just returns one classification.

export interface Classification {
  index: number;
  category: string;
  confidence: number;
}

export const CONFIDENCE_WARN_BELOW = 0.7;

export async function classifyCategories(
  apiBase: string,
  apiKey: string,
  products: any[],
): Promise<Classification[]> {
  if (!products || products.length === 0) return [];
  const res = await fetch(`${apiBase}/classify-categories`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    },
    body: JSON.stringify({ products }),
  });
  if (!res.ok) {
    // Non-fatal — caller falls back to empty classifications
    return products.map((_, i) => ({ index: i, category: '', confidence: 0 }));
  }
  const json = await res.json();
  const arr = Array.isArray(json?.classifications) ? json.classifications : [];
  const byIdx = new Map<number, Classification>();
  arr.forEach((c: any) => {
    if (typeof c?.index === 'number') {
      byIdx.set(c.index, {
        index: c.index,
        category: String(c.category || ''),
        confidence: Number(c.confidence) || 0,
      });
    }
  });
  return products.map((_, i) => byIdx.get(i) || { index: i, category: '', confidence: 0 });
}
